<template>
  <Wrapper>
    <div class="container-fluid pb-0">
      <TopMobileSearch />
      <!-- <ChannelCategories /> -->
      <!-- <hr> -->
      <FeaturedVideos />
      <!-- <hr class="mt-0"> -->
      <!-- <PopularChannels /> -->
    </div>
  </Wrapper>
</template>

<script>
export default {
  components: {
    TopMobileSearch: () => import('@/components/layout/TopMobileSearch'),
    // ChannelCategories: () => import('@/components/ChannelCategories'),
    FeaturedVideos: () => import('@/components/FeaturedVideos'),
    // PopularChannels: () => import('@/components/PopularChannels'),
  },
};
</script>
